export const MINORS_AMOUNT_KEY = 'MINORS_AMOUNT';
export const MINORS_OUTBOUND_KEY = 'MINORS_OUTBOUND';
export const MINORS_INBOUND_KEY = 'MINORS_INBOUND';

export const MINORS_DATE_FORMAT = 'YYYY-MM';
